import React from "react"

const CapText = ({children}) => {
    return (
        <span className={'textCap'}>{children}</span>
    )
}
export default CapText
